'use client';
import { useMemo, Fragment } from 'react';
import { theme } from '@wanteddev/wds-theme';
import WdsThemeContext from '../context/index.mjs';
import { jsx } from '@emotion/react/jsx-runtime';

// src/theme-provider/index.tsx
var ThemeProvider = ({
  theme: localTheme = "light",
  children,
  provider
}) => {
  const engineTheme = useMemo(() => {
    switch (localTheme) {
      case "light":
        return theme.light;
      case "dark":
        return theme.dark;
      default: {
        console.error("WDS: \uC62C\uBC14\uB978 Theme \uAC12\uC744 \uC124\uC815\uD588\uB294\uC9C0 \uD655\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4.");
      }
    }
  }, [localTheme]);
  const Provider = provider ?? Fragment;
  return /* @__PURE__ */ jsx(WdsThemeContext.Provider, { value: engineTheme, children: Boolean(provider) ? /* @__PURE__ */ jsx(Provider, { theme: engineTheme, children }) : children });
};
var theme_provider_default = ThemeProvider;

export { theme_provider_default as default };
